import { combineReducers } from 'redux';
import meals from './ducks/Meals/reducer';
import auth from './ducks/Auth/reducer';
import orders from './ducks/Orders/reducer';
import ordersDetail from './ducks/OrdersDetail/reducer';
import ingredients from './ducks/Ingredients/reducer';
import global from './ducks/Global/reducer';
import videoLibrary from './ducks/VideoLibrary/reducer';
import stripeReducer from './ducks/Stripe/reducer';
import mealPlan from './ducks/MealPlan/reducer';
import scheduledStream from './ducks/ScheduledStream/reducer';
import { videoReducer } from './ducks/video/reducer';

export const rootReducer = combineReducers({
  meals,
  auth,
  orders,
  ordersDetail,
  ingredients,
  global,
  videoLibrary,
  stripeReducer,
  mealPlan,
  scheduledStream,
  video: videoReducer,
});
